import { useState, useEffect } from "react";
import { endOfDay, startOfDay } from "date-fns";
import { Filter } from "../../../config/companies/config";

export const useBoardFilters = (initialFilters: Filter[]) => {
  const [activeFilters, setActiveFilters] = useState<Filter[]>([]);

  //initial filter value (Today s date for example)
  useEffect(() => {
    const filters = initialFilters.map((f) => {
      switch (f.type) {
        case "date":
          return {
            ...f,
            value: {
              startDate: startOfDay(new Date()),
              endDate: endOfDay(new Date()),
            },
          };
        default:
          return f;
      }
    });

    setActiveFilters(filters as Filter[]);
  }, []);

  const applyFilters = (data: any[], filters: Filter[]) => {
    let filtered = [...data];

    filters.forEach((filter) => {
      if (filter.type === "date" && filter.value) {
        const { startDate, endDate } = filter.value;
        if (startDate && endDate) {
          filtered = filtered.filter((item) => {
            const itemDate = item[filter.field];
            if (!itemDate) return false;

            const timestamp = itemDate?.toDate
              ? itemDate.toDate()
              : new Date(itemDate);

            const startOfDayDate = startOfDay(startDate);
            const endOfDayDate = endOfDay(endDate);

            return timestamp >= startOfDayDate && timestamp <= endOfDayDate;
          });
        }
      }

      if (filter.type === "dropdown" && filter.value) {
        const selectedValue = String(filter.value).trim();
        const defaultOptionValue =
          filter.options && filter.options.length > 0
            ? String(filter.options[0] ?? "").trim()
            : "";
        const isNoFilterSelected =
          selectedValue.length === 0 || selectedValue === defaultOptionValue;

        if (!isNoFilterSelected) {
          filtered = filtered.filter((item) => {
            const itemRawValue = item[filter.field];
            const itemValue =
              itemRawValue != null ? String(itemRawValue).trim() : "";
            return itemValue === selectedValue;
          });
        }
      }
    });

    return filtered;
  };

  const handleFilterChange = (newFilters: Filter[]) => {
    setActiveFilters(newFilters);
  };

  return {
    activeFilters,
    handleFilterChange,
    applyFilters,
  };
};
